import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { requireAuth } from "../auth/RequireAuth";
import {
  TimeclockManagerPage,
  timeclockManagerLoader,
} from "./TimeclockManagerPage";

const TimeclockManagerIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/timeclock-manager") {
    navigate(`/timeclock-manager/list`);
  }

  return <Outlet />;
};

export const timeclockManagerRouter = {
  path: "/timeclock-manager",
  id: "timeclock-manager",
  element: <TimeclockManagerIndex />,
  handle: {
    crumb: () => (
      <Breadcrumb name="Timeclock Manager" href="/timeclock-manager/list" />
    ),
  },
  loader: requireAuth(),
  children: [
    {
      path: "list",
      id: "timeclock-manager-list",
      element: <TimeclockManagerPage />,
      loader: timeclockManagerLoader,
    },
  ],
};
